import analytics from '@utils/analytics';
import useQueryString from '@utils/useQueryString';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BookAnAppointmentModal from './BookAnAppointmentModal';
const BookAnAppointmentAction = (props) => {
    const { t } = useTranslation();
    const [showOverlay, setShowOverlay] = useQueryString('bookanappointment', false, true);
    return (React.createElement(React.Fragment, null,
        props.disabled && React.createElement("p", { className: "bold mb-24 mt-24" }, t('store.bookanappointment.disabled')),
        React.createElement("button", { disabled: props.disabled, type: "button", className: "button button--secondary", onClick: () => {
                setShowOverlay(true);
                analytics.storelocatorAction(props.store.name, 'book appointment');
                // analytics.reserveInBoutique(props.product.masterId);
            } },
            React.createElement("span", null, t('button.bookappointment'))),
        props.store && React.createElement(BookAnAppointmentModal, Object.assign({ store: props.store, isOpen: showOverlay }, props, { onRequestClose: () => setShowOverlay(false) }))));
};
export default BookAnAppointmentAction;
